// @flow

import type {
  Order,
} from 'hfty-model-orders/types'

// Constants
import {
  TREE,
  BRANCH,
} from 'hfty-model-orders'

import traverse from 'fc-utils/traverse'

type OrdersSelector = (state: Object) => Array<Order>

export default (traverse([TREE, BRANCH]): OrdersSelector)
